import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import { Remove_VehicleType_Option_bulkImport, Add_VehicleType_Option_bulkImport } from "../../../../../../../Redux/actions/actionNames";

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showpoper: false,
      active:false,
      selected:null
    };
    this.anchorEl = React.createRef();
  }

  handleactive = () => {
    if (this.optionisSaved()) {
      this.props.dispatch(Remove_VehicleType_Option_bulkImport(this.props.id,this.props.bulkId))
    } else {
      this.props.dispatch(Add_VehicleType_Option_bulkImport({
        name:this.props.name,
        id:this.props.id,
        type:"boolean"
      },this.props.bulkId))
    }

  };


  optionisSaved() {
    let booll = false;
     booll = this.props.options.find((item) => {
      return item.id === this.props.id;
    });
    if(booll){
      return true
    }else{
      return false
    }
  }

  render() {
    const { t } = this.props;
    return (
      <React.Fragment >
        <clickableservice ref={this.anchorEl} id={this.props.id} onClick={this.handleactive} className={`blimopit ${this.optionisSaved() && "avtiveServiceOptions blimopitActive"}`}>
          {this.props.title}
        </clickableservice>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state,ownProps) => ({
  activeVehicleType: ownProps.ActiveItem.vehicleType.selectedVehicleType ,
  options:ownProps.ActiveItem.vehicleType.options,
  bulkId : ownProps.ActiveItem.id
});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(App));
